import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { PiezeoDashboardService } from "../../../../../app/services/piezo-dashboard.service";

@Component({
  selector: "app-piezo-table",
  templateUrl: "./piezo-table.component.html",
  styleUrl: "./piezo-table.component.scss",
  standalone: true,
  imports: [CommonModule, MatTooltip],
})
export class PiezoTable {
  sensors: any[] = [];
  asset_ids=[];
  em_asset_ids=[]
  sensorTableData: any = {};
  show_snd_acs=true;
  sid='';
  srv = inject(PiezeoDashboardService);

  ngOnInit() {
    let counter=0
    let subsystem_data = null;
    this.srv.subsystem_data$.subscribe(async (data) => {
      console.log(`Subsystem data updated in piezo table: ${++counter}`);
      subsystem_data = data;
      this.sid=subsystem_data.id
      this.sensors = JSON.parse(subsystem_data.device_position);
      this.asset_ids=this.sensors.filter(s=>s.master_type == 4).map(s=>s.asset_id)
      this.em_asset_ids=this.sensors.filter(s=>s.master_type != 4).map(s=>s.asset_id)
      await Promise.all([this.fetchSensorsTableData(),this.fetchEmSensorsTableData()])
    });
    let count=this.sensors.filter(s=>s.master_type!=4 && s.master_type !=1).length;
    if(count) this.show_snd_acs=true;
    else this.show_snd_acs=false
  }

  async fetchSensorsTableData() {
    this.srv.fetchSensorsTableData(localStorage.getItem('user_id'), this.asset_ids.join(',')).subscribe((data) => {
      Object.keys(data).map((asset_id) => {
        let metric_data = data[asset_id];
        data[asset_id].displacement = [];
        data[asset_id].acceleration = [];
        data[asset_id].velocity = [];
        data[asset_id].temperature = [];
        metric_data.map((m) => {
          console.log(m.metric_group);
          if (m.metric_group == "velocity") data[asset_id].velocity.push(m);
          else if (m.metric_group == "temperature")
            data[asset_id].temperature.push(m);
          else if (m.metric_group == "acceleration")
            data[asset_id].acceleration.push(m);
          else if (m.metric_group == "displacement")
            data[asset_id].displacement.push(m);
        });
        this.sensorTableData = {...this.sensorTableData,...data};
      });
    });
  }

  async fetchEmSensorsTableData() {
    this.srv.fetchEmSensorsTableData(localStorage.getItem('user_id'), this.em_asset_ids.join(','),this.sid).subscribe((data) => {
      Object.keys(data).map((asset_id) => {
        let metric_data = data[asset_id];
        data[asset_id].displacement = [];
        data[asset_id].acceleration = [];
        data[asset_id].velocity = [];
        data[asset_id].temperature = [];
        data[asset_id].audible = [];
        data[asset_id].ultrasound = [];
        metric_data.map((m) => {
          if (m.metric_group == "velocity") 
            data[asset_id].velocity.push(m);
          else if (m.metric_group == "temperature")
            data[asset_id].temperature.push(m);
          else if (m.metric_group == "acceleration")
            data[asset_id].acceleration.push(m);
          else if (m.metric_group == "displacement")
            data[asset_id].displacement.push(m);
          else if (m.metric_group == "audible")
            data[asset_id].audible.push(m);
          else if (m.metric_group == "sound")
            data[asset_id].ultrasound.push(m);
          
        });
        this.sensorTableData = {...this.sensorTableData,...data};
      });
    });
  }
}
